import { useState } from "react"
import ReactHtmlParser from 'react-html-parser'
import Modal from "../components/ui/Modal"
import Button from "../components/ui/Button"
import CharacterData from "../data/CharacterData"
import '../styles/pages/character.scss'
import Title from "../components/ui/Title"

const Character = () => {

    const [current, changeCurrent] = useState(1)
    const setCurrent = (index) =>{
        changeCurrent(index)
    }
    
    return (
        <div className="page-container">
            <Title text="Characters" size="full"/>
            <CharacterTree/>
            <h2 className="character-title">MEET THE TEAM!</h2>
            <div className="team-list">
                {
                    [...Array(4)].map((e,i)=>(
                        <Modal component={
                            <CharacterPage index={i} changeCharacter={setCurrent} current={current}/>
                        }>
                            <TeamCharacter index={i} setCurrent={setCurrent} onClick={()=>{
                                setCurrent(i)
                            }}/>
                        </Modal>
                    ))
                }
            </div>
            <h3 className="other-title">
                OTHER CHARACTERS
            </h3>
            <div className="other-list">
                {
                    [...Array(17)].map((e,index)=>(
                        <Modal component={
                            <CharacterPage index={index} changeCharacter={setCurrent} current={current}/>
                        }>
                            <OtherCharacter index={index+4} setCurrent={setCurrent} onClick={()=>{
                                setCurrent(index+4)
                            }}/>
                            <div>
                            </div>
                        </Modal>
                    ))
                }
            </div>
        </div>
    )
}

const CharacterTree = () => {
    return (
        <section className="character-tree">
            <Modal component={<img src="./img/character-tree.webp" alt="Trails from Zero Character Tree" className="character-tree_image"/>}>
                <div className="tree-preview">
                    <img src="./img/character-tree-preview.webp" alt="Trails from Zero Character Tree" />
                </div>
            </Modal>            
        </section>
    )
}

const TeamCharacter = ({index, setCurrent}) => (
    <div className="team-character" onClick={()=>{
        setCurrent(index)
    }}>
        <div className="team-image">
            <img src={`${process.env.PUBLIC_URL}/img/characters/${CharacterData[index]["image"]}.webp`} alt={CharacterData[index]["name"]} />
        </div>
        <h1 className="team-title">
            {
                CharacterData[index]["name"]
            }
        </h1>
    </div>
)

const OtherCharacter = ({index, setCurrent}) => (
    <div className="other-character" onClick={()=>{
        setCurrent(index)
    }}>
        <img src={`${process.env.PUBLIC_URL}/img/characters/head/${CharacterData[index]["image"]}.webp`} alt={CharacterData[index]["name"]} />
    </div>
)

const CharacterPage = ({index, changeCharacter, current}) => (
    <div className="character-page">
        <div className="character-wrapper">
            <div className="character-info">
                <h1 className="character-name">
                    {CharacterData[current]["name"]}
                </h1>
                <h1 className="character-age">
                    {CharacterData[current]["age"]}
                </h1>
                <h2 className="character-quote">
                    {CharacterData[current]["quote"]}
                </h2>
                <p className="character-bio">
                    {
                        ReactHtmlParser(CharacterData[current]["bio"])
                    }
                </p>
            </div>
            <div className="character-image">
                <img src={`${process.env.PUBLIC_URL}/img/characters/${CharacterData[current]["image"]}.webp`} alt={CharacterData[current]["name"]}/>
            </div>
        </div>
        <div className="next-container">
            {
                (current !== 0) && <Button
                    text="Previous"
                    type="gradient"
                    color="blue"
                    onClick={()=>{
                        if(index >= 0) {
                            changeCharacter(current-1)
                        }
                    }}
                />
            }
            {
                (current !== CharacterData.length-1) && <Button
                    text="Next"
                    type="gradient"
                    color="blue"
                    onClick={()=>{
                        if(current !==  CharacterData.length-1) {
                            changeCharacter(current+1)
                        }
                    }}
                />
            }
        </div>
    </div>
)

export default Character;